import { Outlet } from "react-router-dom";

const ReportLayout = () => {
  return (
    <><Outlet /></>
  );
};

export default ReportLayout;